import styled from 'styled-components';
import {device} from '../../styled/device';
import {Button} from '../../components/Button';

export const Wrapper = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  grid-column-gap: 30px;

  @media (max-width: ${device.laptop}) {
    flex-direction: column;
    grid-row-gap: 30px;
    align-items: center;
  }

  @media (max-width: ${device.tablet}) {
    padding-bottom: 50px;
  }
`;

export const Info = styled.div`
  max-width: 545px;
  border: 1px solid #e6e8ec;
  border-radius: 24px;
  padding: 40px 30px 40px 25px;
`;

export const InfoTitle = styled.div`
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 18px;
`;

export const InfoDescription = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 16px;
`;

export const ButtonStyled = styled(Button)`
  font-size: 15px;
  color: #2148ff;
`;

export const SecondaryButton = styled(Button)`
  margin: 10px auto 0 auto;
`;
